import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoSerpiente = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Serpiente - Predicciones Diarias | Midstino</title>
        <meta name="description" content="Horóscopo chino del signo Serpiente. Predicciones diarias de amor, trabajo y salud para los nacidos en los años de la Serpiente." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="serpiente" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Serpiente</h1>
              <p className="text-muted-foreground">Años: 1929, 1941, 1953, 1965, 1977, 1989, 2001, 2013, 2025</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu magnetismo misterioso está particularmente fuerte hoy, Serpiente. Tu intuición sobre las emociones ajenas te guiará en el amor. Las parejas disfrutarán de conversaciones profundas y significativas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu sabiduría y capacidad analítica brillarán hoy. Es momento de usar tu inteligencia estratégica. Soluciones creativas a problemas complejos llegarán con facilidad.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu conexión mente-cuerpo es poderosa. Prácticas meditativas o yoga te ayudarán a mantener tu equilibrio interno. Escucha tu intuición sobre lo que tu cuerpo necesita.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será perfecto para explorar la profundidad emocional en tus relaciones. Tu sensualidad natural creará momentos íntimos memorables. Los solteros atraerán personas intelectualmente estimulantes.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu perspicacia te dará ventaja en negociaciones importantes. Confía en tu instinto para detectar oportunidades ocultas. Tu paciencia estratégica dará frutos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía está en buen balance. Actividades que combinen movimiento suave con concentración mental serán especialmente beneficiosas. Tai chi o natación serían ideales.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de intensidad emocional y conexiones profundas. Tu naturaleza apasionada pero selectiva atraerá relaciones significativas. Las parejas explorarán nuevos niveles de intimidad.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu sabiduría será tu mayor activo. Decisiones importantes se beneficiarán de tu capacidad de ver más allá de lo obvio. El éxito llegará a través de la estrategia cuidadosa.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu energía interna equilibrada esta semana. Tu naturaleza reflexiva necesita tanto actividad como quietud. Alterna entre movimiento consciente y momentos de contemplación.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoSerpiente;
